<template>
  <div>
    <div class="block">
      <el-carousel trigger="click" :interval="5000" height="450px">
        <!-- <el-carousel-item>
          <div class="banner-contain0"></div>
        </el-carousel-item> -->
        <el-carousel-item>
          <div class="banner-contain1">
            <div class="banner-chunk">
              <h1 class="banner-title">赋能智慧医疗产业</h1>
              <h3 class="banner-name">共享医疗服务资源</h3>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="banner-contain2">
            <div class="banner-chunk">
              <h1 class="banner-title">联合服务</h1>
              <h3 class="banner-name">平台+信息化+服务</h3>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="newbtn-contain">
        <div class="banner-btm">
          <div class="news-left">
            <div @click="leftClick"><i class="fa fa-angle-left"></i></div>
            <div @click="rightClick"><i class="fa fa-angle-right"></i></div>
            <div class="transition-contain">
              <transition name="fade1" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[bannerIndex].url"
                  class="transition-text"
                  v-if="
                    bannerData[bannerIndex].name ==
                    '前海高扬联合创办并授牌100个中心城市的线下实体“好医工 – 共享服务中心”'
                  "
                >
                  {{ bannerData[bannerIndex].name }}
                </router-link>
              </transition>
              <transition name="fade2" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[bannerIndex].url"
                  class="transition-text"
                  v-if="
                    bannerData[bannerIndex].name ==
                    '2020年为什么这么多医疗器械公司一直招人'
                  "
                >
                  {{ bannerData[bannerIndex].name }}
                </router-link>
              </transition>
              <transition name="fade3" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[bannerIndex].url"
                  class="transition-text"
                  v-if="
                    bannerData[bannerIndex].name ==
                    '如何使医疗设备发挥出最佳的功能日益重要'
                  "
                >
                  {{ bannerData[bannerIndex].name }}
                </router-link>
              </transition>
              <transition name="fade4" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[bannerIndex].url"
                  class="transition-text"
                  v-if="
                    bannerData[bannerIndex].name ==
                    '医疗器械行业趋势及设备维修技术探讨'
                  "
                >
                  {{ bannerData[bannerIndex].name }}
                </router-link>
              </transition>
              <transition name="fade5" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[bannerIndex].url"
                  class="transition-text"
                  v-if="
                    bannerData[bannerIndex].name ==
                    '医疗器械的售后维修服务正逐渐成为下一个风口'
                  "
                >
                  {{ bannerData[bannerIndex].name }}
                </router-link>
              </transition>
              <transition name="fade6" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[bannerIndex].url"
                  class="transition-text"
                  v-if="
                    bannerData[bannerIndex].name ==
                    '医疗设备日常巡检保养的重要性'
                  "
                >
                  {{ bannerData[bannerIndex].name }}
                </router-link>
              </transition>
            </div>
          </div>
          <div class="news-right">
            <router-link
              tag="a"
              :to="{ path: 'News', query: { id: 1 } }"
              class="more-test"
              >MORE<i class="fa fa-angle-right"></i
            ></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Data: [
        {
          img: "../../../../static/images/banner1.png",
        },
        {
          img: "../../../../static/images/banner2.png",
        },
      ],
      bannerData: [
        {
          name: "前海高扬联合创办并授牌100个中心城市的线下实体“好医工 – 共享服务中心”",
          url: "/News/6",
        },
        {
          name: "2020年为什么这么多医疗器械公司一直招人",
          url: "/News/1",
        },
        {
          name: "如何使医疗设备发挥出最佳的功能日益重要",
          url: "/News/2",
        },
        {
          name: "医疗器械行业趋势及设备维修技术探讨",
          url: "/News/3",
        },
        {
          name: "医疗器械的售后维修服务正逐渐成为下一个风口",
          url: "/News/4",
        },
        {
          name: "医疗设备日常巡检保养的重要性",
          url: "/News/5",
        },
      ],
      bannerIndex: 0,
    };
  },
  created() {},

  methods: {
    leftClick() {
      if (this.bannerIndex == 0) {
        this.bannerIndex = 5;
      } else if (this.bannerIndex == 1) {
        this.bannerIndex = 0;
      } else if (this.bannerIndex == 2) {
        this.bannerIndex = 1;
      } else if (this.bannerIndex == 3) {
        this.bannerIndex = 2;
      } else if (this.bannerIndex == 4) {
        this.bannerIndex = 3;
      } else if (this.bannerIndex == 5) {
        this.bannerIndex = 4;
      }
    },
    rightClick() {
      if (this.bannerIndex == 0) {
        this.bannerIndex = 1;
      } else if (this.bannerIndex == 1) {
        this.bannerIndex = 2;
      } else if (this.bannerIndex == 2) {
        this.bannerIndex = 3;
      } else if (this.bannerIndex == 3) {
        this.bannerIndex = 4;
      } else if (this.bannerIndex == 4) {
        this.bannerIndex = 5;
      } else if (this.bannerIndex == 5) {
        this.bannerIndex = 0;
      }
    },
  },
};
</script>

<style scoped lang="less">
.block {
  position: relative;
  z-index: 1;

  .newbtn-contain {
    width: 1170px;
    margin: 0 auto;
    margin-top: -38px;
    background: lightblue;
    z-index: 99999;
    display: flex;
    flex-direction: row;
    align-items: flex-end;

    .banner-btm {
      width: 1170px;
      height: 72px;
      background: #fff;
      margin: 0 auto;
      z-index: 999;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      box-shadow: 0px 13px 42px rgba(0, 0, 0, 0.05);

      .news-left {
        width: 70%;
        height: 72px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-left: 40px;
        box-sizing: border-box;
        position: relative;

        .fa {
          font-size: 20px;
          color: #b7b7b7;

          &:hover {
            color: #3488ea;
          }
        }

        div:nth-of-type(1) {
          cursor: pointer;
        }

        div:nth-of-type(2) {
          margin-left: 40px;
          cursor: pointer;
        }

        .transition-contain {
          width: 100%;
          height: 100%;
          line-height: 72px;

          .transition-text {
            margin: 0 auto;
            overflow-y: auto;
            overflow-x: hidden;
            position: absolute;

            margin-left: 40px;
            color: #666666;
            font-size: 13px;
            cursor: pointer;
            display: flex;
            flex-direction: column;

            &:hover {
              color: #3488ea;
            }
          }
        }
      }

      .news-right {
        width: 30%;
        height: 72px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        padding-right: 40px;
        box-sizing: border-box;

        .more-test {
          margin-right: 3px;
          cursor: pointer;
          color: #666666;
          font-size: 13px;
          font-family: "FZCYJ";
          letter-spacing: 1px;

          .fa-angle-right {
            color: #666666;
            font-size: 16px;
            margin-left: 3px;
          }
        }

        div:hover {
          color: #3488ea;

          .fa-angle-right {
            color: #3488ea;
          }
        }
      }
    }
  }

  .banner-contain0 {
    width: 100%;
    height: 450px;
    background: url(../../../../static/images/banner4.jpg) no-repeat center
      center;
  }

  .banner-contain1 {
    width: 100%;
    height: 450px;
    background: url(../../../../static/images/banner1.jpg) no-repeat center
      center;

    .banner-chunk {
      width: 1170px;
      height: 450px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .banner-title {
        color: #003e92;
        font-size: 24px;
        font-weight: 500;
        line-height: 0;
      }

      .banner-name {
        width: 12%;
        font-size: 15px;
        color: #0064b7;
        opacity: 0.9;
        padding: 0.2px 10px 0.2px;
        margin: 20px 0;
        line-height: 1px;
        border-left: 130px solid #0064b7;
        border-right: 130px solid #0064b7;
        text-align: center;
        font-family: "FZCYJ";
        letter-spacing: 1px;
        font-weight: 400;
      }
    }
  }

  .banner-contain2 {
    width: 100%;
    height: 450px;
    background: url(../../../../static/images/banner2.jpg) no-repeat center
      center;

    .banner-chunk {
      width: 1170px;
      height: 450px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 130px;

      .banner-title {
        color: #003e92;
        font-size: 24px;
        font-weight: 500;
        line-height: 0;
      }

      .banner-name {
        width: 12%;
        font-size: 15px;
        color: #0064b7;
        opacity: 0.9;
        padding: 0.2px 10px 0.2px;
        margin: 20px 0;
        line-height: 1px;
        border-left: 130px solid #0064b7;
        border-right: 130px solid #0064b7;
        text-align: center;
        font-family: "FZCYJ";
        letter-spacing: 1px;
        font-weight: 400;
      }
    }
  }
}

.fade1-enter {
  opacity: 0;
}

.fade2-enter {
  opacity: 0;
}

.fade3-enter {
  opacity: 0;
}

.fade4-enter {
  opacity: 0;
}

.fade5-enter {
  opacity: 0;
}

.fade6-enter {
  opacity: 0;
}

.fade1-enter-active {
  transition: opacity 1.3s;
}

.fade2-enter-active {
  transition: opacity 1.3s;
}

.fade3-enter-active {
  transition: opacity 1.3s;
}

.fade4-enter-active {
  transition: opacity 1.3s;
}

.fade5-enter-active {
  transition: opacity 1.3s;
}

.fade6-enter-active {
  transition: opacity 1.3s;
}

.fade1-leave-to {
  transition: 0.8s;
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}

.fade2-leave-to {
  transition: 0.8s;
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}

.fade3-leave-to {
  transition: 0.8s;
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}

.fade4-leave-to {
  transition: 0.8s;
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}

.fade5-leave-to {
  transition: 0.8s;
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}

.fade6-leave-to {
  transition: 0.8s;
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}

// .fade1-enter{
//   opacity: 1;
// }
// .fade2-enter{
//   opacity: 1;
// }
// .fade3-enter{
//   opacity: 1;
// }
// .fade4-enter{
//   opacity: 1;
// }
// .fade5-enter{
//   opacity: 1;
// }
// .fade1-enter-active, .fade1-leave-active {
//   transition: all 1s;
// }
// .fade2-enter-active, .fade2-leave-active {
//   transition: all 1s;
// }
// .fade3-enter-active, .fade3-leave-active {
//   transition: all 1s;
// }
// .fade4-enter-active, .fade4-leave-active {
//   transition: all 1s;
// }
// .fade5-enter-active, .fade5-leave-active {
//   transition: all 1s;
// }

// .fade1-enter, .fade1-leave-to{
//   opacity: 0;
//   transform: translateY(30px);
//   position: absolute;
// }
// .fade2-enter, .fade2-leave-to{
//   opacity: 0;
//   transform: translateY(30px);
//   position: absolute;
// }
// .fade3-enter, .fade3-leave-to{
//   opacity: 0;
//   transform: translateY(30px);
//   position: absolute;
// }
// .fade4-enter, .fade4-leave-to{
//   opacity: 0;
//   transform: translateY(30px);
//   position: absolute;
// }
// .fade5-enter, .fade5-leave-to{
//   opacity: 0;
//   transform: translateY(30px);
//   position: absolute;
// }
</style>


// WEBPACK FOOTER //
// src/views/Home/common/banner.vue